<template>
  <div class="albums-content">
    <ul class="album-list">
      <li v-for="album in sortedAlbums" :key="album.id"><i class="fas fa-book"></i>&nbsp;&nbsp;<router-link :to="albumPages(album)">{{album.name}}</router-link></li>
    </ul>
    <AlbumCreateContainer />
  </div>
</template>

<script>
import { albumPages } from '../utils/routing'
import AlbumCreateContainer from './AlbumCreateContainer'
export default {
  props: ['albums'],
  computed: {
    sortedAlbums() {
      const copy = this.albums.slice()
      copy.sort((a, b) => a.name.localeCompare(b.name))
      return copy
    },
  },
  components: {
    AlbumCreateContainer
  },
  methods: {
    albumPages,
  }
}
</script>

<style lang="stylus" scoped>

ul 
  list-style none
  padding-left 0
  margin-left 0

li
  list-style none
  padding-left 0
  margin-left 0
  
.albums-mobile 

  a
    color #f2cf63

  li 
    color #054350
</style>
